import { TransactionListItem } from "@common/schemas/transaction.schema";
import { MatchSummaryItem } from "@components/accounting/transactionMatch/aggregateMatches";
import { getTransferMatchPreview } from "@components/accounting/transactionMatch/transferMatchPreview";

type AccrualMatchRow = MatchSummaryItem & { amount?: number };

interface CategoryMatchIconTransaction {
    amount?: number;
    pairedTransfer?: TransactionListItem["pairedTransfer"];
    accrualMatches?: readonly AccrualMatchRow[] | null;
    transactionMatches?: TransactionListItem["transactionMatches"];
    accrualMatchSuggestions?: TransactionListItem["accrualMatchSuggestions"];
    accrualAccountId?: string | null;
}

interface CategoryMatchLink {
    isShown: boolean;
    documentMatches: readonly MatchSummaryItem[];
}

interface LedgerMatchLinkParams {
    transaction: CategoryMatchIconTransaction;
    isGlFirst: boolean;
    isGlFirstInitializing: boolean;
    isReviewVariant: boolean;
    isAccrualBasis: boolean;
}

function confirmedAccrualMatches(
    matches: readonly AccrualMatchRow[] | null | undefined,
): AccrualMatchRow[] {
    return (matches ?? []).filter((match) => typeof match.amount === "number");
}

export function getCategoryMatchLink(
    transaction: CategoryMatchIconTransaction,
): CategoryMatchLink {
    const preview = getTransferMatchPreview({
        ...transaction,
        accrualMatches: confirmedAccrualMatches(transaction.accrualMatches),
    });
    const isDocumentMatch =
        preview.kind === "accrualMatch" || preview.kind === "cashDocument";
    return {
        isShown: preview.kind !== "suggestion" && preview.kind !== "empty",
        documentMatches: isDocumentMatch ? preview.items : [],
    };
}

export function getLedgerMatchLink({
    transaction,
    isGlFirst,
    isGlFirstInitializing,
    isReviewVariant,
    isAccrualBasis,
}: LedgerMatchLinkParams): CategoryMatchLink {
    const matchLink = getCategoryMatchLink(transaction);
    const isLedgerEligible =
        isGlFirst &&
        !isGlFirstInitializing &&
        !isReviewVariant &&
        !isAccrualBasis;
    return { ...matchLink, isShown: isLedgerEligible && matchLink.isShown };
}
